import React from 'react'
import Chart from 'react-apexcharts'

interface HorizontalBarChartProps {
  categories: any[] | undefined
  data: any[] | undefined
  seriesName: string | string[]
  width?: string
  height?: string
  title?: string
  titleXAxis?: string
  titleYAxis?: string
}

export const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  categories,
  data,
  seriesName,
  width,
  height,
  titleXAxis = '',
  titleYAxis = ''
}) => {
  const configuration: any = {
    options: {
      colors: ['#0063E3'],
      chart: {
        id: 'basic-bar'
      },
      xaxis: {
        categories: categories,
        title: {
          text: titleXAxis
        }
      },
      yaxis: {
        title: {
          text: titleYAxis
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: '65%'
        },
        dataLabels: {
          position: 'top'
        }
      },
      stroke: {
        colors: ['transparent'],
        width: 5
      },
      grid: {
        show: false,

        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      }
    },
    series: [
      {
        name: seriesName,
        data: data
      }
    ]
  }

  return (
    <div className='app'>
      <div className='row'>
        <div className='mixed-chart'>
          <Chart
            options={configuration.options}
            series={configuration.series}
            type='bar'
            width={width}
            height={height}
          />
        </div>
      </div>
    </div>
  )
}
